import { SortDirection } from 'Core/interfaces'

export const ID_ASC = {
	field: 'id',
	order: SortDirection.ASC
}

export const ID_DESC = {
	field: 'id',
	order: SortDirection.DESC
}

export const NAME_ASC = {
	field: 'name',
	order: SortDirection.ASC
}

export const CODE_ASC = {
	field: 'code',
	order: SortDirection.ASC
}
